import {
    AppointmentServiceApiConfiguration,
    AppointmentService,
    ResourceService,

} from './services/appointmentService';

export const NGA_APPOINTMENT_SERVICES = [
    AppointmentServiceApiConfiguration,
    AppointmentService,
    ResourceService,
];
